import { render } from "./BookingLoginPage.vue?vue&type=template&id=2e29240e"
import script from "./BookingLoginPage.vue?vue&type=script&lang=js"
export * from "./BookingLoginPage.vue?vue&type=script&lang=js"

import "./BookingLoginPage.vue?vue&type=style&index=0&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2e29240e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e29240e', script)) {
    api.reload('2e29240e', script)
  }
  
  module.hot.accept("./BookingLoginPage.vue?vue&type=template&id=2e29240e", () => {
    api.rerender('2e29240e', render)
  })

}

script.__file = "src/views/BookingLoginPage.vue"

export default script